import React, { useCallback } from "react";
import { useWorkspaceRuleGroups } from "@api/rules.api";
import { useCreateRuleGroup } from "../../../../api/ruleGroups.api";
import { useWorkspaceContext } from "../../../../state/workspaceContext";
import { RuleGroupForm, RuleGroupSchema } from "./RuleGroupForm";

interface CreateRuleGroupModalProps {
    isAccounting: boolean;
    onHide: () => void;
}

export const CreateRuleGroupModal: React.FC<CreateRuleGroupModalProps> = ({
    isAccounting,
    onHide,
}) => {
    const { activeWorkspaceId } = useWorkspaceContext();
    const createMutation = useCreateRuleGroup(onHide);
    const ruleGroups = useWorkspaceRuleGroups();

    const onSubmit = useCallback(
        (ruleGroupData: RuleGroupSchema) => {
            const newOrder =
                (ruleGroups.data?.ruleGroups ?? []).filter(
                    (g) => g.isAccounting === isAccounting,
                ).length + 1;

            return createMutation.mutateAsync({
                workspaceId: activeWorkspaceId ?? "",
                ruleGroup: {
                    name: ruleGroupData.name,
                    icon: isAccounting ? "bank" : "briefcase",
                    isAccounting,
                    order: newOrder,
                },
            });
        },
        [
            createMutation,
            isAccounting,
            activeWorkspaceId,
            ruleGroups.data?.ruleGroups,
        ],
    );

    return (
        <RuleGroupForm
            onHide={onHide}
            isPending={createMutation.isPending}
            onSubmitRuleGroup={onSubmit}
            isAccounting={isAccounting}
        />
    );
};
